window.onDeleteInManageProfile = deleteIcon => {
  const label = deleteIcon.closest(".deleteParentElement");
  label.classList.add("hidden");
}
